export function formatCurrencyDecimal(value) {
  let numericValue = parseFloat(value) / 100

  return numericValue.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

export function formatCurrency(value) {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  })
}

export function removeFormatCurrency(value) {
  const onlyNumber = value.replace('R$', '').replace(',', '.').replace(/\./g, '')
  const convertToDecimal = parseFloat(onlyNumber) / 100

  return convertToDecimal
}
